import EditDate from "../components/EditDate"
import { getLastUpdated, slugify } from "../functions/utils"
import FreeText from "./FreeText"

const NewExtensions = ({ data, slug, disclaimer, freeText }) => {
    const date = getLastUpdated(null, data)
    return (
        <article id={slugify(slug)}>
            <div className="flex-between-centered">
                <h2 className="content_h2">{slug}</h2>
                <EditDate date={date} />
            </div>
            {disclaimer && <i style={{display: 'block', marginBottom: 7}}>{disclaimer}</i>}
             <div>
                {data && data.map((product, i) => {
                    if (!product || !product.fields) return
                    const { name, slug, } = product.fields
                    return (
                    <div className='block-style' key={i}>
                        {name && <h4 className="content_h4" style={{marginBottom: 0}}>
                            <a href={`/extensions/${slug}`}>{name}</a>
                        </h4>}
                    </div>
                    )
                })}
            </div>
            {freeText && <FreeText data={freeText} slug="additionalInfo" />}
        </article>
     )
}

export default NewExtensions